import * as Yup from "yup"
import { useFormik } from 'formik'
import { createSelector } from "reselect"
import 'react-toastify/dist/ReactToastify.css'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { withTranslation } from 'react-i18next'
import withRouter from '../../../../components/Common/withRouter'
import BreadCrumb from '../../../../components/Common/BreadCrumb'
import {
    Card, CardBody, CardFooter, CardHeader,
    Col, Form, FormFeedback, Input, Label, Row
} from "reactstrap"
import {
    createAllowance as onCreateAllowance,
    updateAllowance as onUpdateAllowance,
} from "../../../../slice/thunks"

function CreateAllowance(props) {
    const { id, allowanceName, rate, taxable, cnpsContribution } = useParams()
    const dispatch = useDispatch()
    const history = useNavigate()

    const selectLayoutState = (state) => state.Payroll
    const AllowanceProperties = createSelector(
        selectLayoutState,
        (setting) => ({
            createAllowance: setting.createAllowance,
            updateAllowance: setting.updateAllowance,
            allowance: setting.allowance,
            error: setting.error,
        })
    )
    const { createAllowance, error, updateAllowance } = useSelector(AllowanceProperties)
    const [isEdit, setIsEdit] = useState(false)

    useEffect(() => {
        if (id && id.length > 0) {
            setIsEdit(true)
        }
    }, [])

    useEffect(() => {
        if (createAllowance && !error) {
            validation.resetForm()
            history("/payroll/setting/allowances")
        }
    }, [createAllowance, error])

    useEffect(() => {
        if (updateAllowance && !error) {
            setIsEdit(false)
            validation.resetForm()
            history("/payroll/setting/allowances")
        }
    }, [updateAllowance, error])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: id || '',
            allowanceName: allowanceName || '',
            rate: rate ? Number(rate) : '',
            taxable: taxable === 'true' ? true : false,
            cnpsContribution: cnpsContribution === 'true' ? true : false,
        },

        validationSchema: Yup.object({
            allowanceName: Yup.string().required(props.t("you_need_provide_name")),
            rate: Yup.number()
                .typeError(props.t("rate_must_be_number"))
                .min(0, props.t("rate_must_be_positive")),
        }),

        onSubmit: (values) => {
            const payload = {
                allowanceName: values.allowanceName,
                rate: values.rate,
                taxable: values.taxable,
                cnpsContribution: values.cnpsContribution,
            }

            if (isEdit) {
                dispatch(onUpdateAllowance({ data: payload, id: values.id }))
                .unwrap()
                .then(() => {
                    validation.resetForm()
                    history("/payroll/setting/allowances")
                })
            } else {
                dispatch(onCreateAllowance(payload))
                .unwrap()
                .then(() => {
                    validation.resetForm()
                    history("/payroll/setting/allowances")
                })
            }
        },
    })

    return (
        <div className="all-payrollSettings-setting px-3">
            <div className="patients-list py-4 px-2">
                <div className="container-fluid">
                    <div className="row list-patients d-flex justify-content-between">
                        <Link to="/payroll/setting/allowances" className="col-lg-5">
                            <BreadCrumb
                                title={props.t("payroll_settings")}
                                pageTitle={props.t("allowances")}
                            />
                        </Link>
                    </div>

                    <Card className="container p-0">
                        <CardHeader className="bg-light p-3">
                            {isEdit ? props.t("edit") : props.t("create_new")}
                        </CardHeader>

                        <Form
                            className="tablelist-form"
                            autoComplete="off"
                            onSubmit={(e) => {
                                e.preventDefault()
                                validation.handleSubmit()
                                return false
                            }}
                        >
                            <CardBody>
                                <div className="container">
                                    <div>
                                        {/* Allowance Name */}
                                        <Col xl={12} sm={12}>
                                            <div className="mb-3">
                                                <Label htmlFor="allowanceName-field" className="form-label">
                                                    {props.t("name")} <span className="text-danger">*</span>
                                                </Label>
                                                <Input
                                                    name="allowanceName"
                                                    id="allowanceName-field"
                                                    type="text"
                                                    className="form-control"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.allowanceName || ""}
                                                    invalid={
                                                        validation.touched.allowanceName &&
                                                        !!validation.errors.allowanceName
                                                    }
                                                />
                                                {validation.touched.allowanceName && validation.errors.allowanceName && (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.allowanceName}
                                                    </FormFeedback>
                                                )}
                                            </div>
                                        </Col>

                                        {/* Rate */}
                                        <Col xl={12} sm={12}>
                                            <div className="mb-3">
                                                <Label htmlFor="rate-field" className="form-label">
                                                    {props.t("rate")}
                                                </Label>
                                                <Input
                                                    name="rate"
                                                    id="rate-field"
                                                    type="number"
                                                    min="0"
                                                    step="any"
                                                    className="form-control"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.rate}
                                                    invalid={
                                                        validation.touched.rate &&
                                                        !!validation.errors.rate
                                                    }
                                                    disabled={!validation.values.taxable }
                                                />
                                                {validation.touched.rate && validation.errors.rate && (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.rate}
                                                    </FormFeedback>
                                                )}
                                            </div>
                                        </Col>
<Row>
  
                                        {/* Taxable Toggle */}
                                        <Col xl={6} sm={12}>
                                            <div className="mb-3 d-flex align-items-center gap-3">
                                                <Label htmlFor="taxable-field" className="form-label mb-0">
                                                    {props.t("taxable")}
                                                </Label>
                                                <div className="form-check form-switch">
                                                    <Input
                                                        name="taxable"
                                                        id="taxable-field"
                                                        type="checkbox"
                                                        role="switch"
                                                        className="form-check-input"
                                                        checked={validation.values.taxable}
                                                        onChange={validation.handleChange}
                                                    />
                                                </div>
                                                <span className="text-muted small">
                                                    {validation.values.taxable ? props.t("yes") : props.t("no")}
                                                </span>
                                            </div>
                                        </Col>

                                        {/* CNPS Contribution Toggle */}
                                        <Col xl={6} sm={12}>
                                            <div className="mb-3 d-flex align-items-center gap-3">
                                                <Label htmlFor="cnpsContribution-field" className="form-label mb-0">
                                                    {props.t("cnps_contribution")}
                                                </Label>
                                                <div className="form-check form-switch">
                                                    <Input
                                                        name="cnpsContribution"
                                                        id="cnpsContribution-field"
                                                        type="checkbox"
                                                        role="switch"
                                                        className="form-check-input"
                                                        checked={validation.values.cnpsContribution}
                                                        onChange={validation.handleChange}
                                                    />
                                                </div>
                                                <span className="text-muted small">
                                                    {validation.values.cnpsContribution ? props.t("yes") : props.t("no")}
                                                </span>
                                            </div>
                                        </Col>
</Row>
                                    </div>
                                </div>
                            </CardBody>

                            <CardFooter>
                                <div className="p-3">
                                    <Row className="align-items-center">
                                        <div className="col-sm">
                                            <span className="text-danger align-middle">
                                                * : {props.t("required_fields")}
                                            </span>
                                        </div>
                                        <div className="col-sm-auto">
                                            <div className="hstack gap-2 justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => {
                                                        validation.resetForm()
                                                        setIsEdit(false)
                                                        history("/payroll/setting/allowances")
                                                    }}
                                                >
                                                    {props.t("close")}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success"
                                                >
                                                    {isEdit ? props.t("update") : props.t("save")}
                                                </button>
                                            </div>
                                        </div>
                                    </Row>
                                </div>
                            </CardFooter>
                        </Form>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default withRouter(withTranslation()(CreateAllowance))